import { Button } from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import DescriptionIcon from "@mui/icons-material/Description";
import type { EditableCallbackParams } from "ag-grid-community";

type Props = EditableCallbackParams;

export const LOTOLinkButton = ({ data }: Props) => {
	if (data.id !== -1) {
		return (
			<Grid2 container spacing={1} style={{ alignItems: "center" }}>
				{data?.LOTONumber && (
					<Grid2 size={{ md: 12, xs: 12 }}>
						<Button
							href={`https://web.conformit.com/Print.aspx?Prockey=${data?.LOTONumber}`}
							target="_blank"
							rel="noopener noreferrer"
							fullWidth
							color="primary"
							style={{
								textDecoration: "none",
								fontWeight: 500,
								fontSize: "12px",
								borderRadius: "3px",
							}}
						>
							<DescriptionIcon />
						</Button>
					</Grid2>
				)}
			</Grid2>
		);
	} else return <></>;
};
